// 設定最大温度
export const MAX_SETTING_TEMP = 60;
// 設定最低温度
export const MIN_SETTING_TEMP = -30;

// 什器の設定温度によって表示色が違うため、表示色を判別するために使用する定数
export const THRESHOLDS = [MIN_SETTING_TEMP, 0, 10, 25, MAX_SETTING_TEMP];
